import { render } from "./TrackInAlbum.vue?vue&type=template&id=711e2234"
import script from "./TrackInAlbum.vue?vue&type=script&lang=js"
export * from "./TrackInAlbum.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__